import { Component } from '../../scripts/component';

class ReleaseImageGallery extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.currentIndex = 0;
    this.isTransitioning = false;
    this.setupControls();
  }

  setupControls() {
    const prevButton = this.querySelector('[ref="prevButton"]');
    const nextButton = this.querySelector('[ref="nextButton"]');
    const track = this.querySelector('[ref="desktopTrack"]');

    if (!track) return;

    this.track = track;
    this.visibleItems = 3;

    this.originalItems = [...track.children];
    this.totalItems = this.originalItems.length;

    if (this.totalItems <= this.visibleItems) return;

    const cloneCount = this.visibleItems;
    this.cloneCount = cloneCount;

    // Keep a reference to the first original item for ordered insertion
    const firstOriginal = this.originalItems[0];

    // Append clones of first N items at the end
    for (let i = 0; i < cloneCount; i++) {
      const clone = this.originalItems[i].cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    // Prepend clones of last N items (in correct order) before the first original
    for (let i = 0; i < cloneCount; i++) {
      const srcIndex = this.totalItems - cloneCount + i;
      const clone = this.originalItems[srcIndex].cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.insertBefore(clone, firstOriginal);
    }

    this.allItems = [...track.children];

    // Set initial position without transition (index 0 = first real item)
    this._setPositionInstant(this._getOffset(0));

    // Only react to the transform property to avoid double-firing
    this._boundTransitionEnd = (e) => {
      if (e.propertyName === 'transform') {
        this._onTransitionEnd();
      }
    };
    this.track.addEventListener('transitionend', this._boundTransitionEnd);

    if (prevButton) prevButton.addEventListener('click', () => this.prev());
    if (nextButton) nextButton.addEventListener('click', () => this.next());
  }

  prev() {
    if (this.isTransitioning) return;
    this.isTransitioning = true;
    this.currentIndex--;
    this._animateTo(this.currentIndex);
  }

  next() {
    if (this.isTransitioning) return;
    this.isTransitioning = true;
    this.currentIndex++;
    this._animateTo(this.currentIndex);
  }

  _getOffset(index) {
    const trackPos = index + this.cloneCount;
    const itemWidth = this.allItems[0].offsetWidth;
    const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
    return trackPos * (itemWidth + gap);
  }

  _animateTo(index) {
    this.track.style.transition = 'transform 300ms ease';
    this.track.style.transform = `translateX(-${this._getOffset(index)}px)`;
  }

  _setPositionInstant(offset) {
    this.track.style.transition = 'none';
    this.track.style.transform = `translateX(-${offset}px)`;
    // Force synchronous reflow so the jump is applied before any future transition
    void this.track.offsetHeight;
  }

  _onTransitionEnd() {
    this.isTransitioning = false;

    // Wrap forward: scrolled past last real position → jump to equivalent real position
    if (this.currentIndex >= this.totalItems) {
      this.currentIndex -= this.totalItems;
      this._setPositionInstant(this._getOffset(this.currentIndex));
    }
    // Wrap backward: scrolled before first real position → jump to equivalent real position
    else if (this.currentIndex < 0) {
      this.currentIndex += this.totalItems;
      this._setPositionInstant(this._getOffset(this.currentIndex));
    }
  }

  disconnectedCallback() {
    if (this.track && this._boundTransitionEnd) {
      this.track.removeEventListener('transitionend', this._boundTransitionEnd);
    }
    super.disconnectedCallback();
  }
}

if (!customElements.get('release-image-gallery')) {
  customElements.define('release-image-gallery', ReleaseImageGallery);
}
